import React from 'react'
import useHeader from '../Header/hooks/useHeader'
import Default from './components/Default';
import Wallet from './components/Wallet';
import Credit from './components/Credit';
import { initialPath } from '~misc/paths';

const Cta = ({title}) => {
  const { path } = useHeader();

  const renderVariations = () => {
    switch(path)
    {
      case `${initialPath}/carteira/limite`:
        return <Credit />;
      case `${initialPath}/carteira/busca/online`:
        return <Wallet title={title} />;
      default:
        return <Default title={title} />;
    }
  }

  return (
    <>
      {renderVariations()}
    </>
  )
}

export default Cta
